<template>
  <v-form v-model="valid" ref="psychStepTwoForm">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="4">
          <p class="font-weight-medium text-center">
            {{
              this.$vuetify.lang.t(
                "$vuetify.main.psychologistReg.stepTwo.mainTreatmentMethod"
              )
            }}
          </p>
          <v-checkbox
            v-for="(item, i) in main_treatment_method_Items"
            :key="i + item.title"
            v-model="selectedMethods"
            v-bind:label="item.title"
            v-bind:value="item.id"
            :disabled="isDisabledMethod(item.id)"
            class="mt-0 pt-0 mb-1"
            hide-details="true"
            @change="saveDebounced"
          ></v-checkbox>
          <v-divider class="mt-2 mb-5"></v-divider>
          <p class="font-weight-medium text-center">
            {{
              this.$vuetify.lang.t(
                "$vuetify.main.psychologistReg.stepTwo.additionalEducation"
              )
            }}
          </p>
          <v-checkbox
            v-for="(item, i) in additionalEducation"
            v-model="selected"
            :disabled="isDisabledAddEducation(additionalEducation[i].id)"
            v-bind:label="item.title"
            :key="item.title + i"
            v-bind:value="item.id"
            hide-details="true"
            class="mt-0 pt-0 mb-0 pb-0"
            @change="saveDebounced"
          >
          </v-checkbox>
          <v-checkbox
            v-model="anotherSelectTextArea"
            :label="
              this.$vuetify.lang.t(
                '$vuetify.main.psychologistReg.stepTwo.another'
              )
            "
            value=""
            @change="saveDebounced"
          >
          </v-checkbox>
          <p class="text-center" v-if="anotherSelectTextArea">
            {{
              this.$vuetify.lang.t(
                "$vuetify.main.psychologistReg.stepTwo.additionalEducationDesk"
              )
            }}
          </p>
          <v-textarea
            v-if="anotherSelectTextArea"
            v-model="additional_knowledge_other"
            :rules="[noRussianRule]"
            class="mx-2"
            rows="1"
            auto-grow
            prepend-icon="mdi-comment"
            @input="saveDebounced"
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="1">
          <v-divider v-if="!window.isVisibleDivider" vertical></v-divider>
          <v-divider v-if="window.isVisibleDivider"></v-divider>
        </v-col>
        <v-col cols="12" md="7" class="mt-2">
          <v-row justify="center" class="mb-3">
            <p class="font-weight-medium text-center">
              {{
                this.$vuetify.lang.t(
                  "$vuetify.main.psychologistReg.stepTwo.problems"
                )
              }}
            </p>
          </v-row>
          <div v-for="(events, index) in psychologistEvents" v-bind:key="index">
            <p class="ma-0 pt-0 font-weight-medium">
              {{
                $vuetify.lang.t(
                  `$vuetify.view.psychologists.specialization.${index}`
                )
              }}
            </p>
            <div class="events__wrapper">
              <v-checkbox
                v-ripple
                @change="handleChangeEvents(index, i)"
                v-model="selected_checkboxes[index]"
                v-for="(event, i) in events"
                ripple
                v-bind:label="event"
                :key="i"
                v-bind:value="i"
                :hide-details="true"
                class="item"
              >
              </v-checkbox>
            </div>
            <!--            <v-divider-->
            <!--              v-if="index === 'life_event_problems'"-->
            <!--              class="mt-2 mb-5"-->
            <!--            ></v-divider>-->
            <!--            <p-->
            <!--              class="font-weight-medium pb-2"-->
            <!--              v-if="index === 'life_event_problems'"-->
            <!--            >-->
            <!--              {{-->
            <!--                $vuetify.lang.t("$vuetify.main.patientReg.stepTwo.whatDiscuss")-->
            <!--              }}-->
            <!--            </p>-->
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import Vue from "vue";
import { noRussianRule } from "@/utils/noRussian";
import { mapGetters } from "vuex";
import debounce from '@/utils/debounce'

export default {
  name: "stepTwo",
  data() {
    return {
      saveDebounced: function() {},
      valid: false,
      window: {
        isVisibleDivider: false,
        width: 0,
      },
      selected_checkboxes: {
        'life_event_problems': [],
        'career_problems': [],
        'mental_health_condition_problems': [],
        'relationship_problems': [],
      },
      selected: [],
      selectedMethods: [],

      selectedLifeEvents: [],
      mentalHealthConditionProblems: [],
      relationshipProblems: [],
      careerProblems: [],

      anotherSelectTextArea: false,
      additional_knowledge_other: "",
      radioGroup: 1,
      column: null,
      enabled: false,
      psychologistEvents: null,
    };
  },
  watch: {
    anotherSelectTextArea() {
      if (!this.anotherSelectTextArea) {
        this.additional_knowledge_other = "";
      }
    },
  },
  created() {
    this.$store.dispatch("user/getPsychologistFilter").then((response) => {
      this.psychologistEvents = response.data.data;
    });
    window.addEventListener("resize", this.handleClientWidth);
    this.handleClientWidth();
    this.$eventHub.$on("psych-step-two-form_validate-form", this.validate);
    this.loadUser();
    this.saveDebounced = debounce(() => {
      this.saveData();
    }, 400)
  },
  beforeDestroy() {
    this.$eventHub.$off("psych-step-two-form_validate-form", this.validate);
    this.saveDebounced.cancel();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleClientWidth);
  },
  methods: {
    noRussianRule,
    loadUser() {
      if (this.user.psychologistQuestionnaire.profile.main_treatment_methods) {
        this.selectedMethods = this.user.psychologistQuestionnaire.profile.main_treatment_methods;
      } 
      if (this.user.psychologistQuestionnaire.profile.additional_knowledge) {
        this.selected = this.user.psychologistQuestionnaire.profile.additional_knowledge;
      } 
      if (this.user.psychologistQuestionnaire.profile.additional_knowledge_other) {
        this.additional_knowledge_other = this.user.psychologistQuestionnaire.profile.additional_knowledge_other;
        
        if (typeof this.additional_knowledge_other === 'string' && this.additional_knowledge_other.trim() !== '') {
          this.anotherSelectTextArea = true;
        }
      } 

      

      if (this.user.psychologistQuestionnaire.general_questions.life_event_problems) {
        this.selectedLifeEvents = this.user.psychologistQuestionnaire.general_questions.life_event_problems;
        this.selected_checkboxes['life_event_problems'] = this.selectedLifeEvents;
      } 
      if (this.user.psychologistQuestionnaire.general_questions.mental_health_condition_problems) {
        this.mentalHealthConditionProblems = this.user.psychologistQuestionnaire.general_questions.mental_health_condition_problems;
        this.selected_checkboxes['mental_health_condition_problems'] = this.mentalHealthConditionProblems;
      } 
      if (this.user.psychologistQuestionnaire.general_questions.relationship_problems) {
        this.relationshipProblems = this.user.psychologistQuestionnaire.general_questions.relationship_problems;
        this.selected_checkboxes['relationship_problems'] = this.relationshipProblems;
      } 
      if (this.user.psychologistQuestionnaire.general_questions.career_problems) {
        this.careerProblems = this.user.psychologistQuestionnaire.general_questions.career_problems;
        this.selected_checkboxes['career_problems'] = this.careerProblems;
      } 
    },
    isDisabledMethod(value) {
      return this.selectedMethods.length >= 3 && !this.selectedMethods.includes(value);
    },
    isDisabledAddEducation(value) {
      return value == 'couples_therapy' && this.selectedMethods.length == 1 && this.selectedMethods.includes('nlp');
    },
    handleChangeEvents(index, value) {
      this.saveDebounced();
      switch (index) {
        case "life_event_problems":
          this.handleItemInArray(value, this.selectedLifeEvents);
          break;
        case "career_problems":
          this.handleItemInArray(value, this.careerProblems);
          break;
        case "mental_health_condition_problems":
          this.handleItemInArray(value, this.mentalHealthConditionProblems);
          break;
        case "relationship_problems":
          this.handleItemInArray(value, this.relationshipProblems);
          break;
      }
    },
    handleItemInArray(value, array) {
      let itemIndex = array.indexOf(value);
      itemIndex === -1 ? array.push(value) : array.splice(itemIndex, 1);
    },
    handleClientWidth() {
      this.window.width = window.innerWidth;
      this.window.isVisibleDivider = this.window.width < 960;
    },
    saveData() {
      this.$store.dispatch("user/setQuestionnaireProfile", {
        main_treatment_methods: this.selectedMethods,
        additional_knowledge: this.selected,
        additional_knowledge_other: this.additional_knowledge_other,
      });
      this.$store.dispatch("user/setQuestionnaireGeneral", {
        life_event_problems: this.selectedLifeEvents,
        mental_health_condition_problems: this.mentalHealthConditionProblems,
        relationship_problems: this.relationshipProblems,
        career_problems: this.careerProblems,
      });
    },
    validate() {
      if (this.anotherSelectTextArea && noRussianRule(this.additional_knowledge_other) !== true) {
        Vue.swal({
          target: document.getElementById("main"),
          text: noRussianRule(this.additional_knowledge_other),
          icon: "error",
          toast: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 7000,
        });
        return;
      }
      this.valid =
        this.selectedLifeEvents.length +
        this.mentalHealthConditionProblems.length +
        this.relationshipProblems.length +
        this.careerProblems.length;
      if (this.valid || this.selectedMethods) {
        this.saveData();
        this.$eventHub.$emit("switch-psych-registration-tab", 3);
      } else {
        Vue.swal({
          target: document.getElementById("main"),
          text: this.$vuetify.lang.t(
            "$vuetify.main.patientReg.stepTwo.warning"
          ),
          toast: true,
          position: "top-right",
          icon: "error",
          timer: 4000,
          showConfirmButton: false,
        });
      }
    },
  },

  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
    main_treatment_method_Items() {
      return [
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.art_therapy"
          ),
          id: "art_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.client_centered_psychotherapy"
          ),
          id: "client_centered_psychotherapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.cognitive_behavioral_therapy"
          ),
          id: "cognitive_behavioral_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.body_therapy"
          ),
          id: "body_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.psychoanalysis"
          ),
          id: "psychoanalysis",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.jungian_analysis"
          ),
          id: "jungian_analysis",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.transactional_analysis"
          ),
          id: "transactional_analysis",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.family_therapy"
          ),
          id: "family_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.gestalt_therapy"
          ),
          id: "gestalt_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.psychodrama"
          ),
          id: "psychodrama",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.analytical_psychology"
          ),
          id: "analytical_psychology",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.symboldrama"
          ),
          id: "symboldrama",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.existential_analysis"
          ),
          id: "existential_analysis",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.nlp"
          ),
          id: "nlp",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.positive_psychotherapy"
          ),
          id: "positive_psychotherapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.emdr"
          ),
          id: "emdr",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.schema_therapy"
          ),
          id: "schema_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.emotional_imagery_therapy"
          ),
          id: "emotional_imagery_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.integrative_approach"
          ),
          id: "integrative_approach",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.act_therapy"
          ),
          id: "act_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.hypnotherapy"
          ),
          id: "hypnotherapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.coaching"
          ),
          id: "coaching",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.logotherapy"
          ),
          id: "logotherapy",
        },
      ];
    },
    additionalEducation() {
      return [
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.addictions"
          ),
          id: "addictions",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.eating_disorders"
          ),
          id: "eating_disorders",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.sexology"
          ),
          id: "sexology",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.extreme_situations"
          ),
          id: "extreme_situations",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.couples_therapy"
          ),
          id: "couples_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepTwo.lgbt"
          ),
          id: "lgbt",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.children"
          ),
          id: "children",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.teenagers"
          ),
          id: "teenagers",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.events__wrapper {
  column-count: 2;
  margin-bottom: 20px;
}

.item {
  padding: 8px;
  margin: -4px -4px;
  page-break-inside: avoid;
}
</style>
